import React, { useState } from 'react'
import Modal, { ModalProps } from '../index'

export interface ConfirmationModalProps
  extends Omit<ModalProps, 'isModalVisible' | 'children'> {
  children: JSX.Element
  modalContent?: ModalProps['children']
  shouldPrompt?: boolean
}

const ConfirmationModal = ({
  children,
  modalContent,
  shouldPrompt = true,
  ...restProps
}: ConfirmationModalProps) => {
  const [isModalVisible, setIsModalVisible] = useState(false)

  const onConfirm = () => {
    children.props.onClick?.()
    setIsModalVisible(false)
  }

  const onCancel = () => {
    setIsModalVisible(false)
  }

  const showModal = () => {
    if (shouldPrompt) {
      setIsModalVisible(true)
    } else {
      children.props.onClick?.()
    }
  }

  return (
    <>
      <Modal
        confirmButtonProps={{
          variant: 'danger',
        }}
        {...restProps}
        isModalVisible={isModalVisible}
        onConfirm={onConfirm}
        onCancel={onCancel}
        noPadding
      >
        {modalContent}
      </Modal>
      {React.cloneElement(children, { onClick: showModal })}
    </>
  )
}

export default ConfirmationModal
